<template>
    <div>
        <div class="dialog-content-container">
            <p>Are you sure to delete this record</p>
        </div>
        <div class="dialog-action-container">
            <v-btn color="primary" dark @click="confirmDelete()">Yes</v-btn>
        </div>
    </div>
</template>

<script>
export default {
    props: ["props", "successFn"],
    methods: {
        confirmDelete() {
            var self = this;
            axios({
                method: "DELETE",
                url: this.props.apiUrl,
                params: this.props.data
            }).then(function (response) {
                EventBus.$emit("snackBar", {
                    text: "Row Deleted Succesfully",
                    snackbarColor: "green darken-2"
                });

                self.successFn();
                self.$emit("onClose");
            });
            
        }   
    }
};
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/smallComponents/Dialog/DialogContent/DeleteConfirmation.vue